export default __webpack_public_path__ + "static/pedidosya-6a7bf87fa33c2a1980bea7a37b8d1cb1.png";